import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Box, 
  Card, 
  CardHeader, 
  CardContent, 
  Typography, 
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,} from '@mui/material';
import { CalendarMonth } from '@mui/icons-material';
import { WithdrawalContext } from '../contexts/WithdrawalContext';
import { formatAmount, convertUtcByCurrency } from '../utils/utils';
import LoadingState from '../components/LoadingState';

const Dashboard = () => {
  const todayDate = useMemo(() => new Date(), []);
  const [ withdrawals, setWithdrawals] = useState([]);
  const { fetchWithdrawals, loading } = useContext(WithdrawalContext);

  useEffect(() => {
    async function fetchData() {
      const result =  await fetchWithdrawals([4], convertUtcByCurrency(todayDate, 'YYYY/MM/DD')); // Pass statusIds and today's date
      setWithdrawals(result || []);
    }
    fetchData();
  }, [fetchWithdrawals, todayDate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        width: '100%',
        paddingBottom: 1.5,
        boxSizing: 'border-box',
      }}
    >
      {loading && (
          <LoadingState fullHeight />
      )}

      {!loading && (
        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
          <Card sx={{ 
            margin: 2, 
            backgroundColor: 'transparent', 
            color: 'var(--primary-color)', 
            border: '2px solid var(--primary-color)', 
            borderRadius: 2,
            padding: 0,
            flexShrink: 0,
          }}>
            <CardContent>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>今日交易数</Typography>
              <Typography variant="h5" sx={{ textAlign: 'right', wordWrap: 'break-word', }}>{ withdrawals?.length || 0 }</Typography>
            </CardContent>
          </Card>

          {/* Transaction List Section */}
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
            <Card sx={{
              backgroundColor: 'var(--bg-secondary-color)',
              margin: '0 16px',
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              minHeight: 0,
            }}>
              {/* Card Header for Date */}
              <CardHeader
                  title={convertUtcByCurrency(todayDate, 'DD/MM/YYYY')}
                  titleTypographyProps={{
                    variant: 'subtitle1',
                    fontWeight: 'bold',
                    color: '#000',
                  }}
                  sx={{
                    backgroundColor: 'var(--primary-color)',
                    padding: '8px 16px',
                    borderBottom: '1px solid var(--secondary-color)',
                    '& .MuiCardHeader-action': {
                      margin: 'auto',
                    }
                  }}
                  action={
                    <Typography component="div" sx={{ color: '#c58e20',  display: 'flex', alignItems: 'center' }}>
                      <CalendarMonth sx={{ fontSize: '1.75rem' }} />
                    </Typography>
                  }
              />
              {/* Card Content for Other Data */}
              <CardContent sx={{ padding: '0 0 16px !important', display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
                <Paper
                  elevation={0}
                  sx={{
                    width: '100%',
                    overflow: 'hidden',
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    minHeight: 0,
                  }}
                >
                  {/* Table Container */}
                  <TableContainer
                    sx={{
                      flex: 1,
                      minHeight: 0,
                      overflowY: 'auto',
                      WebkitOverflowScrolling: 'touch',
                      overscrollBehavior: 'contain',
                    }}
                  >
                    <Box sx={{ px: 2 }}>
                      <Table stickyHeader sx={{
                        '& th': { padding: 1, fontSize: '0.9rem', fontWeight: 'bold', color: 'var(--secondary-color)', backgroundColor: 'var(--bg-secondary-color)', borderColor: 'var(--secondary-color)' },
                        '& td': { padding: 1, color: '#fff', borderColor: 'var(--secondary-color)' },
                      }}>
                      {/* Table Header */}
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">订单号</TableCell>
                          <TableCell align="center">金额</TableCell>
                        </TableRow>
                      </TableHead>

                      {/* Table Body */}
                      <TableBody>
                        { withdrawals.length > 0 ? (
                          withdrawals.map((withdrawal, index) => (
                          <TableRow key={index} hover>
                            <TableCell>{withdrawal.orderId}</TableCell>
                            <TableCell align="right">{formatAmount(withdrawal.amount)}</TableCell>
                          </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell align="center" colSpan={2}>
                              暂无记录
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                      </Table>
                    </Box>
                  </TableContainer>
                </Paper>
              </CardContent>
            </Card>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Dashboard;
